import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { supabase } from "../lib/supabaseClient";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) {
      const t = setTimeout(() => navigate("/login", { replace: true }), 2500);
      return () => clearTimeout(t);
    }
    let active = true;
    (async () => {
      // Route clinicians to their portal, everyone else to the GP dashboard.
      const { data: clin } = await supabase
        .from("clinicians")
        .select("id")
        .eq("email", user.email)
        .maybeSingle();
      if (!active) return;
      navigate(clin ? "/clinician" : "/dashboard", { replace: true });
    })();
    return () => { active = false; };
  }, [user, loading, navigate]);

  return (
    <div className="flex h-screen w-full flex-col items-center justify-center gap-3 bg-background" data-testid="auth-callback-page">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
      <p className="text-sm text-slate-500">Completing sign-in…</p>
    </div>
  );
}
